import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { ImageViewerModule } from '../../components/image-viewer/image-viewer.module';

import { AnalysisViewComponent } from '../../components/analysis/analysis-view/analysis-view.component';
import { DocumentFilesComponent } from '../../components/analysis/analysis-view/document-content/document-files/document-files.component';
import { DocumentMetadataComponent } from '../../components/analysis/analysis-view/document-content/document-metadata/document-metadata.component';
import { ImageFilesComponent } from '../../components/analysis/analysis-view/image-content/image-files/image-files.component';
import { ImageHierarchyComponent } from '../../components/analysis/analysis-view/image-content/image-hierarchy/image-hierarchy.component';
import { ReportListViewComponent } from '../../components/report-list-view/report-list-view.component';
import { BaseAnalysisImagesViewDirective } from '../../components/image-views/base-analysis-images-view/base-analysis-images-view.directive';
import { ImageGridViewComponent } from '../../components/image-views/image-grid-view/image-grid-view.component';
import { ImageListViewComponent } from '../../components/image-views/image-list-view/image-list-view.component';
import { SidebarMetadataContentComponent } from '../../components/sidebar-metadata-content/sidebar-metadata-content.component';
import { SidebarFlatListMetadataContentComponent } from '../../components/sidebar-flat-list-metadata-content/sidebar-flat-list-metadata-content.component';
import { SidebarImageFilterComponent } from '../../components/sidebar-image-filter/sidebar-image-filter.component';
import { ImageContentComponent } from '../../components/analysis/analysis-view/image-content/image-content.component'
import { DocumentContentComponent } from '../../components/analysis/analysis-view/document-content/document-content.component'
import { KimeraGridCvViewerComponent } from '../../components/analysis/analysis-view/kimera-grid-cv-content/kimera-grid-cv-viewer/kimera-grid-cv-viewer.component'
import { KimeraGridCvContentComponent } from '../../components/analysis/analysis-view/kimera-grid-cv-content/kimera-grid-cv-content.component';
import { KimeraGridMetadataSidebarComponent } from '../../components/analysis/analysis-view/kimera-grid-cv-content/kimera-grid-metadata-sidebar/kimera-grid-metadata-sidebar.component'
import { KimeraGenericModelBoxComponent } from '../../components/analysis/analysis-view/kimera-grid-cv-content/kimera-generic-model-box/kimera-generic-model-box.component'
import { KimeraColourPickerComponent } from '../../components/analysis/analysis-view/kimera-grid-cv-content/kimera-colour-picker/kimera-colour-picker.component';
import {AskTheAuthorModule} from '../../components/ask-the-author/ask-the-author.module';
import {ContactModalModule} from '../../components/contact-modal/contact-modal.module';
import { NotificationBannerComponent } from '../../components/notification-banner/notification-banner.component';
import { ProgressTrackerInformContentComponent } from '../../components/analysis/analysis-view/progress-tracker-inform-content/progress-tracker-inform-content.component';

@NgModule({
  declarations: [
    AnalysisViewComponent,
    DocumentContentComponent,
    DocumentMetadataComponent,
    DocumentFilesComponent,
    ImageContentComponent,
    ImageHierarchyComponent,
    ImageFilesComponent,
    SidebarMetadataContentComponent,
    SidebarFlatListMetadataContentComponent,
    SidebarImageFilterComponent,
    ReportListViewComponent,
    BaseAnalysisImagesViewDirective,
    ImageGridViewComponent,
    ImageListViewComponent,
    KimeraGridCvViewerComponent,
    KimeraGridCvContentComponent,
    KimeraGridMetadataSidebarComponent,
    NotificationBannerComponent,
    KimeraGenericModelBoxComponent,
    ProgressTrackerInformContentComponent,
    KimeraGenericModelBoxComponent,
    KimeraColourPickerComponent,
  ],
  imports: [
    SharedModule,
    ImageViewerModule,
    AskTheAuthorModule,
    ContactModalModule,
  ],
  exports: [
    AnalysisViewComponent,
    DocumentMetadataComponent,
    ProgressTrackerInformContentComponent,
  ],
})
export class AnalysisModule {}
